<template>
  <div id="app">  
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>
      
      <div class="main-div">
        <!-- <Toaster></Toaster>  -->
      <el-container class="main-div parentDiv">
        <splitpanes class="default-theme defaultStyle custom-splite" > 
          <pane  size="100" class="SideBarLeft">
            <prime />
            <!-- <SearchCondition /> -->
          </pane>
    
          <pane class="SideBarRight">                             
            <SideBar class="SidePane"/>
           </pane> 
        </splitpanes>  
      </el-container> 
      </div>  
      <el-container class="footer-div">
        <el-footer class="footer-element">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>

import Header from './common/header.vue';
import prime from './top_page/mainComponent.vue';
import SideBar from './common/side-bar.vue';
import FooterComponent from './common/footerComponent.vue';
// In your VueJS component.
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
export default {
  name: 'Home',
  components: {
    Header,
    prime,
    SideBar,
    FooterComponent,
    Splitpanes,
    Pane,
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@import '../assets/css/style.css';
.parentDiv {
  padding-top: 12px;
  width: 100%;
  overflow: hidden;
  min-width: 1000px;
}
.SideBarRight, .SideBarRight SideBar {
width: 250px;
}
.SideBarLeft {
  overflow: hidden !important;
  min-width: 750px;
  display: flex !important;
}


/* Split pane style */
.splitpanes__pane {
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.2) inset;
  justify-content: center;
  align-items: center;
  display: flex;
}
.default-theme.defaultStyle .splitpanes__splitter{
border-left: 3px solid #ccc !important;
}

.defaultStyle {
  width: 100%;
  margin: 0px auto;
}


p {
  position: absolute;
  /* bottom: 5px;
  right: 5px; */
  color: #666;
  z-index: 10;
  font-size: 12px;
}

p a {
  color: inherit;
}

.custom-splite {
  margin-bottom: 60px;
}
.sideBar .el-side-bar {
  display: block;
  overflow: hidden;
}
</style>